import { ReactNode } from "react";

import { Popover, PopoverContent, PopoverTrigger } from "../../popover";

import { cn } from "@/lib/utils";

interface FilePreviewWrapperProps {
  isViewing: boolean;
  setIsViewing: (isViewing: boolean) => void;
  trigger: ReactNode;
  children: ReactNode;
  side?: "top" | "bottom" | "left" | "right";
  contentClassName?: string;
}

export const FilePreviewWrapper = ({
  isViewing,
  setIsViewing,
  trigger,
  children,
  contentClassName,
  side = "top",
}: FilePreviewWrapperProps) => (
  <Popover open={isViewing} onOpenChange={setIsViewing} modal>
    <PopoverTrigger asChild>{trigger}</PopoverTrigger>
    <PopoverContent
      className={cn(
        "my-2 max-h-[65vh] min-h-[200px] w-auto max-w-[600px] overflow-y-auto p-3",
        contentClassName,
      )}
      side={side}
    >
      {children}
    </PopoverContent>
  </Popover>
);
